import { Artefact } from "@/lib/artefacts";
import {
    DefineSetupStoreOptions,
    StoreDefinition,
    _ExtractActionsFromSetupStore,
    _ExtractGettersFromSetupStore,
    _ExtractStateFromSetupStore,
    defineStore,
} from "pinia";
import { MaybeRefOrGetter } from "vue";

interface RequiredEntityStoreKeys {
    description: MaybeRefOrGetter<Artefact<"text/markdown"> | undefined>;
    reset: () => Promise<void>;
    isFetching: MaybeRefOrGetter<boolean>;
    isModified: MaybeRefOrGetter<boolean>;
}

export function defineEntityStore<
    Id extends string,
    SS extends RequiredEntityStoreKeys,
>(
    id: Id,
    storeSetup: () => SS,
    options?: DefineSetupStoreOptions<
        Id,
        _ExtractStateFromSetupStore<SS>,
        _ExtractGettersFromSetupStore<SS>,
        _ExtractActionsFromSetupStore<SS>
    >
): StoreDefinition<
    Id,
    _ExtractStateFromSetupStore<SS>,
    _ExtractGettersFromSetupStore<SS>,
    _ExtractActionsFromSetupStore<SS>
> {
    return defineStore(id, storeSetup, options);
}
